
<template>
  <div class="modal-backdrop">
     <div class="modal">
        <div class="modal-header">
          <h3>雇员信息</h3>
        </div>
        <div class="modal-body">
			<div class="row">
				<div class="rowhalf">
					<div class="itemtitle">雇员姓名</div>
					<div class="fielditem"><input v-model="params.insuredName" placeholder="请输入雇员姓名" class="field"/></div>
				</div>
			</div>
			<div class="row">
				<div class="rowhalf">
					<div class="itemtitle">证件类型</div>
					<div class="fielditem">
						<select class="field" v-model="params.insuredCertificatId" @change="insuredCertificatIdSelect">
							<option v-for="item in this.insuredCertificatIdList" :value="item.value">{{item.name}}</option>
						</select>
					</div>
				</div>
				<div class="rowhalf">
					<div class="itemtitle">证件号码</div>
					<div class="fielditem"><input @blur="checkInsuredIdCardNum" v-model="params.insuredIdCardNum" placeholder="请输入雇员证件号码" class="field"/></div>
				</div>
			</div>
			<div class="row">
				<div class="rowhalf">
					<div class="itemtitle">出生日期</div>
					<div class="fielditem">
						<date-picker class="field" v-model="params.birthday" type="date"/>
					</div>
				</div>
				<div class="rowhalf">
					<div class="itemtitle">性别</div>
					<div class="fielditem">
						<select class="field" v-model="params.insuredGender" @change="insuredGenderSelect">
							<option v-for="item in this.genderList" :value="item.value">{{item.name}}</option>
						</select>
					</div>
				</div>
			</div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            <button type="button" class="btn-confirm" @click="confirm">确认</button>
        </div>
    </div>
 
  </div>
</template>
 
<style>
.row{
	width: 100%;
	display: flex;
	margin-top: 15px;
}
.row .rowhalf{
	display: flex;
	width:46% ;
	margin-right: 20px;
}
.row .rowhalf .itemtitle{
	position: relative;
	white-space: nowrap;
	display: flex;
	align-items: center;
	padding-right: 5px;
}
.row .rowhalf .itemtitle:before{
	position: absolute;
	left: -8px;
	color: #ee0a24;
	font-size: 14px;
	content: '*';
}
.row .rowhalf .fielditem{
	width: 100%;
	border: 1px solid #f1f1f1;
	font-size: 0.25rem;
	padding: 0.02rem;
}
.row .rowhalf .fielditem .date-picker--container{
	border:none;
}
.row .rowhalf .fielditem .field{
	width: 100%;
	padding: 4px;
	height: 100%;
	border: none;
}
.Tips{
	width: 500px; 
	/* height: 252px; */
	line-height: 24px; 
	position: absolute; 
	padding: 5px; 
	background: rgb(254, 249, 217); 
	z-index: 999999; 
	color: rgb(140, 57, 1); 
	border: 1px solid rgb(153, 153, 153); 
	font-size: 14px; 
	right: 0px;
	top: 30px;
}
.modal-backdrop { 
    position: fixed; 
    top: 0; 
    right: 0; 
    bottom: 0; 
    left: 0; 
    background-color: rgba(0,0,0,.3); 
    display: flex; 
    justify-content: center; 
    align-items: center; 
}
.modal { 
    background-color: #fff; 
    box-shadow: 2px 2px 20px 1px; 
    overflow-x:auto; 
    display: flex; 
    flex-direction: column;
    border-radius: 16px;
    width: 700px;
} 
.modal-header { 
    border-bottom: 1px solid #eee; 
    color: #313131; 
    justify-content: space-between;
    padding: 15px; 
    display: flex; 
} 
.modal-footer { 
    border-top: 1px solid #eee; 
    justify-content: flex-end;
    padding: 15px; 
    display: flex; 
} 
.modal-body { 
    position: relative; 
    padding: 20px 20px; 
}
.btn-close, .btn-confirm {    
    border-radius: 8px;
    margin-left:16px;
    width:56px;
    height: 36px;
    border:none;
    cursor: pointer;
}
.btn-close {
    color: #313131;
    background-color:transparent;
}
.btn-confirm {
    color: #fff; 
    background-color: #2d8cf0;
}
 
 .textarea{
	 width: 100%;
 }
</style>
 
<script>
import { identifyText } from "../utils/verifyUtils";
import DatePicker from '@hyjiacan/vue-datepicker'
import '@hyjiacan/vue-datepicker/dist/datepicker.css'
export default {
  name: 'PolicyModal',
  
components: {DatePicker},
  props: {  
	insuredInfoList:Array,
	insuredCertificatIdList:Array,
	genderList:Array,
	editData:Object,
	addEditType:String,
  },
  data() {
    return {
		params:{
			  insuredName: "",
			  insuredGender: 1,
			  insuredCertificatTypes: [
			    { id: 0, value: "身份证" },
			    { id: 1, value: "军官证" },
			    { id: 2, value: "护照" },
			    { id: 3, value: "驾驶证" },
			    { id: 4, value: "营业执照" },
			    { id: 5, value: "其他" },
			  ],
			  minDate: new Date(1900, 1, 1),
			  currentDate: new Date(),
			  insuredCertificat: "身份证",
			  insuredCertificatId: 0,
			  showInsuredCertificatPicker: false,
			  insuredIdCardNum: "",
			  showInsuredCalendar: false,
			  birthday: "",
		},
	  }
  }, 
  watch:{
	  editData:{
		  handler(val){
			  if(val!=this.params){
				  this.params=val
			  }
		  },
		  immedieta:true,
	  },
	  insuredInfoList:{
	  		  handler(val){
	  			  if(val!=this.insuredInfoList){
	  				  this.insuredInfoList=val
	  			  }
	  		  },
	  	  immedieta:true,
	  }
  },
  methods: {  
	checkInsuredIdCardNum(){
	  const {insuredCertificatId,insuredIdCardNum} = this.params
	  if(insuredCertificatId == 0 && insuredIdCardNum){
	  	return this.checkIDCardNo(insuredIdCardNum)
	  }
	  return true
	},
	insuredGenderSelect(){
		
	},
	insuredCertificatIdSelect(){
		
	},
    closeSelf() {
        this.$emit("closepolicyme");      
    },
	confirm(){
		const {insuredName,birthday,insuredCertificatId,insuredIdCardNum,insuredGender} = this.params
		if(!insuredName){
			alert('请输入雇员姓名')
			return
		}
		if(!insuredIdCardNum){
			alert('请输入雇员证件号码')
			return
		}
		if(!birthday){
			alert('请选择雇员生日')
			return
		}
		if(!this.checkInsuredIdCardNum()){
			return
		}
		if(this.addEditType=='add'){
			const cardIndex = this.insuredInfoList.findIndex(x=>x.insuredIdCardNum == insuredIdCardNum)
			if(cardIndex != -1){
				alert('请不要输入重复数据，证件号码与第'+(cardIndex+1)+'行重复')
				return
			}
		}
		const data = this.params
		if(data){
			this.$emit("confirmPolicy",{addEditType:this.addEditType,data:data});
		}
	},
	checkIDCardNo(pId) {
	    //判断证件类型是否是身份证
	    var arrVerifyCode = [1, 0, "x", 9, 8, 7, 6, 5, 4, 3, 2];
	    var Wi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
	
	    if (pId.length != 15 && pId.length != 18) {
	        alert("身份证号共有15位或18位");
	        return false;
	    }
	    var Ai = pId.length == 18 ? pId.substring(0, 17) : pId.slice(0, 6) + "19" + pId.slice(6, 16);
	
	    if (!/^\d+$/.test(Ai)) {
	        alert("身份证除最后一位外，必须为数字！");
	        return false;
	    }
	    var yyyy = Ai.slice(6, 10), mm = Ai.slice(10, 12) - 1, dd = Ai.slice(12, 14);
	    var d = new Date(yyyy, mm, dd), now = new Date();
	    var year = d.getFullYear(), mon = d.getMonth(), day = d.getDate();
	    if (year != yyyy || mon != mm || day != dd || d > now) {
	        alert("身份证输入错误！");
	        return false;
	    }
	    for (var i = 0, ret = 0; i < 17; i++)
	        ret += Ai.charAt(i) * Wi[i];
	    Ai += arrVerifyCode[ret %= 11];
	
	    var lpid = pId.toLowerCase();
	
	    if (lpid.length == 18 && lpid != Ai) {
	        alert("身份证输入错误！");
	        return false;
	    }
	    var birthday = new Date(pId.slice(6, 10), pId.slice(10, 12) - 1, pId.slice(12, 14)).Format("yyyy-MM-dd");
		this.params.birthday = birthday
	    var sex = pId.slice(14, 17) % 2 ? "M" : "F";
		if(sex == 'M'){
			this.params.insuredGender = 1
		}else{
			this.params.insuredGender = 2
		}
		return true
	}
  }
}
</script>